import { render, staticRenderFns } from "./mateSticOut.vue?vue&type=template&id=fa936c9c&scoped=true&"
import script from "./mateSticOut.vue?vue&type=script&lang=js&"
export * from "./mateSticOut.vue?vue&type=script&lang=js&"
import style0 from "./mateSticOut.vue?vue&type=style&index=0&id=fa936c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa936c9c",
  null
  
)

export default component.exports